export default {
  name: 'marking--printTicketUpload',
  apiService: 'shoes',
  apiPath: '/admin/print/func/ticket/upload',
  urlParamName: 'marking--printTicketUpload',
};